import { Typography, TypographyProps } from 'omakase';
import { core } from '@tock/coretypes';
import { getGuestsIcon, getGuestsLine } from 'utils/purchase';

import { FunctionComponent } from 'react';
import { SlimPatron } from '@tock/shared/utils/patron';
import { useIsSakeIconSetEnabled } from 'omakase/utils/IconMigrationUtil';

export interface ReservationQuantityDetailProps {
  deliveryServiceProvider?: core.DeliveryServiceProvider;
  isAuthenticated?: boolean;
  purchaseCount: number;
  purchaseOwner?: SlimPatron;
  singleUnitQuantity?: number;
  ticketTypeDescriptiveVariety?: core.DescriptiveVariety;
  ticketTypeVariety?: core.TicketType.Variety;
  typographyVariant?: TypographyProps['variant'];
}

export const ReservationQuantityDetail: FunctionComponent<ReservationQuantityDetailProps> = ({
  deliveryServiceProvider,
  isAuthenticated,
  purchaseCount,
  purchaseOwner,
  singleUnitQuantity,
  ticketTypeDescriptiveVariety,
  ticketTypeVariety,
  typographyVariant = 'body02',
}) => {
  const useSakeIcons = useIsSakeIconSetEnabled();

  const GuestsIcon = getGuestsIcon(
    ticketTypeVariety,
    { useSakeIcons },
    ticketTypeDescriptiveVariety,
    deliveryServiceProvider
  );
  const guestsLine = getGuestsLine(
    ticketTypeVariety,
    purchaseCount,
    purchaseOwner,
    isAuthenticated,
    ticketTypeDescriptiveVariety,
    deliveryServiceProvider,
    singleUnitQuantity
  );
  return (
    <li>
      <GuestsIcon />
      <Typography
        component="span"
        variant={typographyVariant}
        color="fgDefault"
        data-testid="guest-info"
      >
        {guestsLine}
      </Typography>
    </li>
  );
};
